import { MasterHelper } from '../../utilities';

export class RegulationActionDetail {
    id: number;
    userId: number;
    uniqueId: number;
    geography: string;
    country: string;
    mappingID: string;
    regulator: string;
    date: string;
    title: string;
    type: string;
    topic: string;
    impactArea: string;
    status: string;
    actionDate: string;
    effectiveDate: string;
    impact: string;
    assessment: string;

    constructor() {
        this.id = 0;
        this.userId = 0;
        this.uniqueId = 0;
        this.geography = '';
        this.country = '';
        this.mappingID = '';
        this.regulator = '';
        this.date = MasterHelper.getCurrrentDateTime('MM/DD/YYYY');
        this.title = '';
        this.type = '';
        this.topic = '';
        this.impactArea = '';
        this.status = '';
        this.actionDate = MasterHelper.getCurrrentDateTime('MM/DD/YYYY');
        this.effectiveDate = MasterHelper.getCurrrentDateTime('MM/DD/YYYY');
        this.impact = '';
        this.assessment = '';
    }
}


export class RegulationActionDetailCollection {
    data: RegulationActionDetail[];
    totalCount: number;

    constructor() {
        this.data = new Array<RegulationActionDetail>();
        this.totalCount = 0;
    }
}
